const PageFreightQuote = () => import('./PageFreightQuote');

export default {
  path: 'freight-quote',
  children: [
    {
      name: 'FreightQuote',
      params: {
        quoteFreightVolume: null,
      },
      path: '',
      component: PageFreightQuote,
      meta: {
        title: 'Cotação de Frete',
      },
    },
  ],
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/routes.js